import React from 'react';
import {Route} from 'react-router-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

const PrivateRoute = ({
  component: Component,
  admins: {admin, loadingAdmin},
  ...rest
}) => {
  const token = localStorage.getItem('adminTko');
  const CustomRedirect = ({rest, props}) => {
    console.log('here');
    // if (rest.path.includes('shortcut')) {
    //   return <Component {...props} />;
    // } else {
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
    return null;
    // }
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        !admin && !token ? (
          <CustomRedirect rest={rest} props={props} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  admins: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  admins: state.admins,
});
export default connect(mapStateToProps, {})(PrivateRoute);
